import { useState } from 'react';
import { corrigeTout } from '../lib/correcteur';
import { tr, trf } from '../lib/i18n';
import { C } from '../theme/palette';

/**
 * Le mot corrigé tout seul sous une case (« plaintes → plinthes »), avec de
 * quoi revenir au texte tapé si la correction ne convient pas.
 *
 * @param {object} props propriétés
 * @param {[string, string][]} props.corrections mots remplacés (avant, après)
 * @param {() => void} props.onAnnule remet le texte tel qu'il était tapé
 * @returns {import('react').ReactElement|null} la ligne, ou rien sans correction
 */
export function CorrectionFaite({ corrections, onAnnule }) {
  if (!corrections || corrections.length === 0) return null;
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 10.5,
        color: C.teal,
        fontWeight: 700,
        margin: '-4px 0 10px',
      }}
    >
      <span style={{ flex: 1 }}>
        {trf('✓ Corrigé : {0}', corrections.map(([a, b]) => a + ' → ' + b).join(', '))}
      </span>
      <button
        type="button"
        onClick={onAnnule}
        style={{
          border: 'none',
          background: C.tealL,
          color: C.teal,
          fontWeight: 800,
          fontSize: 10,
          borderRadius: 7,
          padding: '4px 9px',
          cursor: 'pointer',
        }}
      >
        {tr('Annuler')}
      </button>
    </div>
  );
}

/**
 * Une case d'une ligne (titre d'un article) qui corrige toute seule les mots
 * du métier à la sortie, comme la désignation de la facture.
 *
 * @param {object} props propriétés
 * @param {string} props.value texte
 * @param {(texte: string) => void} props.onChange reçoit le texte modifié
 * @param {object} [props.style] style de la case
 * @returns {import('react').ReactElement} la case et la correction faite
 */
export function CaseCorrigee({ value, onChange, style }) {
  const [correction, setCorrection] = useState(null);
  return (
    <>
      <input
        value={value ?? ''}
        spellCheck
        autoCorrect="on"
        onChange={(e) => {
          setCorrection(null);
          onChange(e.target.value);
        }}
        onBlur={() => {
          const r = corrigeTout(value || '');
          if (r.corrections.length === 0) return;
          setCorrection({ avant: value, corrections: r.corrections });
          onChange(r.texte);
        }}
        style={style}
      />
      <CorrectionFaite
        corrections={correction?.corrections}
        onAnnule={() => {
          onChange(correction.avant);
          setCorrection(null);
        }}
      />
    </>
  );
}
